import React from 'react';
import Layout from '../components/layout';
import AppointmentScheduler from '../components/AppointmentScheduler';
import { useAuth } from '../components/context/AuthContext';

const AppointmentsPage = () => {
  const { currentUser } = useAuth();

  return (
    <Layout>
      <div className="container mx-auto px-4 py-20">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          {currentUser?.role === 'doctor' ? 'Manage Your Appointments' : 'Schedule an Appointment'}
        </h1>
        <p className="text-gray-600 mb-8">
          {currentUser?.role === 'doctor' 
            ? 'View and manage your upcoming appointments with patients.'
            : 'Book, reschedule, or cancel your appointments with our doctors.'}
        </p>
        
        <AppointmentScheduler />
      </div>
    </Layout>
  );
};

export default AppointmentsPage;